import {
    Component,
    OnChanges,
    OnInit,
    SimpleChange,
    SimpleChanges,
} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ContenutoGenericoService} from "../service/contenuto-generico.service";
import {ContenutoGenerico} from "../model/contenuto-generico";
import {AllegatoService} from "../service/allegato.service";
import {Allegato} from "../model/allegato";
import {Search} from "../common/search";
import {Location} from "@angular/common";
import {MultilinguaService} from "../service/multilingua.service";
import {MenuService} from "../service/menu.service";
import {Multilingua} from "../model/multilingua";
import {SeoService} from "../service/seo.service";
import {DOCS_REPLACE} from "../constants/constants";

@Component({
    selector: "app-componenti-generici",
    templateUrl: "./componenti-generici.component.html",
})
export class ComponentiGenericiComponent implements OnInit, OnChanges {
    public component: string;
    public nomePadre: string;
    public _componente: string;
    public element: ContenutoGenerico;
    public allegato: Allegato;
    public path_immagine: string;
    public loading = true;
    public disclaimer: boolean;
    public lingua: string;

    constructor(
        private contenutoService: ContenutoGenericoService,
        private allegatoService: AllegatoService,
        private multilingueService: MultilinguaService,
        private location: Location,
        private router: Router,
        private menuService: MenuService,
        private seo: SeoService,
        public route: ActivatedRoute
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        const componente: SimpleChange = changes.componente;
        // console.log('prev value: ', componente.previousValue);
        // console.log('got name: ', componente.currentValue);
        this._componente = componente.currentValue.toUpperCase();
    }

    ngOnInit() {
        this.contenutoService.search = new Search<ContenutoGenerico>(
            ContenutoGenerico
        );
        this.route.params.subscribe((param: Params) => {
            // console.log('loading the component');
            if (!param.id) {
                this.route.url.subscribe(() => {
                    const url = this.location.path().split("/");
                    this.component = url.pop();
                });
            } else {
                if (param.id === "aumento-capitale" ||
                    param.id === "capital-increase" ||
                    param.id === "opa-nemo" ||
                    param.id === "opa-cometa" ||
                    param.id === "vto-cometa" ||
                    param.id === "vto-nemo") {
                    console.log("disclaimer_operazioni: " + this.disclaimer);
                    this.disclaimer = true;
                } else {
                    this.disclaimer = false;
                }
                this.component = param.id;
            }
            this.init();
        });
    }

    init() {
        this.contenutoService.find(this.component).subscribe(
            (componenteGenerico) => {
                if (componenteGenerico == null) {
                    this.router.navigate(["/homepage"]);
                }
                this.element = componenteGenerico;
                this.contenutoService
                    .find(this.element.contenitore)
                    .subscribe((padre) => {
                        if (padre) {
                            this.element.nomePadre = padre.titolo;
                        }
                    });
                this.lingua = this.element.lang;
                this.getOtherLangs();
                // this.seo.addSeo(this.element);
                if (this.element && this.element.immagine) {
                    this.allegatoService.find(this.element.immagine).subscribe(
                        (allegato) => {
                            if (allegato) {
                                this.allegato = allegato;
                                this.path_immagine = DOCS_REPLACE(this.allegato.uuid);
                                this.seo.setImage(this.path_immagine);
                            }
                            this.loading = false;
                        },
                        (err) => {
                            this.loading = false;
                            this.contenutoService.search = new Search<ContenutoGenerico>(
                                ContenutoGenerico
                            );
                        }
                    );
                } else {
                    this.loading = false;
                }
            },
            (err) => {
                this.loading = false;
                this.contenutoService.search = new Search<ContenutoGenerico>(
                    ContenutoGenerico
                );
            }
        );
    }

    getOtherLangs() {
        // console.log('searching for langs');
        this.multilingueService.search = new Search<Multilingua>(Multilingua);
        if (this.lingua === "IT") {
            this.multilingueService.search._.it = this.component;
        } else if (this.lingua === "EN") {
            this.multilingueService.search._.eng = this.component;
        } else if (this.lingua === "PT") {
            this.multilingueService.search._.pt = this.component;
        }
        this.multilingueService.getList().subscribe((link) => {
            const lingue = [];
            if (link.length > 0) {
                if (this.lingua === "EN" && link[0].it) {
                    lingue.push("IT");
                }
                if (this.lingua === "IT" && link[0].eng) {
                    lingue.push("EN");
                }
            }
            // console.log('pushing for langs');
            this.menuService.add(lingue);
        });
    }

    accept(event) {
        if (event === true) {
            this.disclaimer = false;
        }
    }
}
